import { Product } from "../types/product";
export const productsData = [
  {
    id: 1,
    calories: 1378.0,
    description:
      "Crunchy to perfection. Includes a bun, fries, and 2 garlic sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 2,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-pfc-4pc-tpos.jpg",
    name: "ALBAIK 4 Piece Chicken Meal",
    price: 7000,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 70,
    priceFractionalUnit: 0,
    options: [],
    nutritionalInformation: [
      {
        calories: 1378.0,
        name: "ALBAIK 4 Piece Chicken Meal",
        quantity: 1,
      },
    ],
    variations: [
      {
        imageUrl:
          "https://images.staging.waseat.albaikcloud.com/spicy-icon.png",
        name: "Spicy",
        productId: 2,
      },
    ],
  },
  {
    id: 4,
    calories: 2582,
    description:
      "Spicy and Crunchy to perfection. Includes 2 buns, fries, and 4 garlic sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 6,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-pfc-8pc-tpos.jpg",
    name: "ALBAIK 8 Piece Spicy Chicken Meal",
    price: 3300,
    allergenInformation: {
      egg: "true",
      soy: "false",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 33,
    priceFractionalUnit: 0,
    options: [
      {
        id: 106347,
        name: "First Sauce",
        required: true,
        multiple: false,
        multipleChoices: false,
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43,
            default: true,
            id: 181553,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106348,
        name: "Second Sauce",
        required: true,
        multiple: false,
        multipleChoices: false,
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43,
            default: true,
            id: 181554,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106349,
        name: "Third Sauce",
        required: true,
        multiple: false,
        multipleChoices: false,
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43,
            default: true,
            id: 181555,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106350,
        name: "Fourth Sauce",
        required: true,
        multiple: false,
        multipleChoices: false,
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43,
            default: true,
            id: 181556,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 740,
        name: "Chicken Chest (Spicy)",
        quantity: 2,
      },
      {
        calories: 542,
        name: "Chicken Thigh (Spicy)",
        quantity: 2,
      },
      {
        calories: 250,
        name: "Chicken Drumstick (Spicy)",
        quantity: 2,
      },
      {
        calories: 194,
        name: "Chicken Wing (Spicy)",
        quantity: 2,
      },
      {
        calories: 376,
        name: "Bread Bun",
        quantity: 2,
      },
      {
        calories: 308,
        name: "Fries",
        quantity: 1,
      },
    ],
    variations: [],
  },
  {
    id: 2,
    calories: 1445.0,
    description:
      "Spicy and Crunchy to perfection. Includes a bun, fries, and 2 garlic sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 7,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-pfc-4pc-tpos.jpg",
    name: "ALBAIK 4 Piece Spicy Chicken Meal",
    price: 1500,
    allergenInformation: {
      egg: "true",
      soy: "false",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 15,
    priceFractionalUnit: 0,
    options: [
      {
        id: 106341,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181547,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181547,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106342,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181548,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181548,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 370.0,
        name: "Chicken Chest (Spicy)",
        quantity: 1,
      },
      {
        calories: 271.0,
        name: "Chicken Thigh (Spicy)",
        quantity: 1,
      },
      {
        calories: 125.0,
        name: "Chicken Drumstick (Spicy)",
        quantity: 1,
      },
      {
        calories: 97.0,
        name: "Chicken Wing (Spicy)",
        quantity: 1,
      },
      {
        calories: 188.0,
        name: "Bread Bun",
        quantity: 1,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
    ],
    variations: [],
  },
  {
    id: 3,
    calories: 2448.0,
    description:
      "Crunchy to perfection. Includes 2 buns, fries, and 4 garlic sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 1,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-pfc-8pc-tpos.jpg",
    name: "ALBAIK 8 Piece Chicken Meal",
    price: 3300,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 33,
    priceFractionalUnit: 0,
    options: [
      {
        id: 106343,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181549,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181549,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106344,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181550,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181550,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106345,
        name: "Third Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181551,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181551,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106346,
        name: "Fourth Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181552,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181552,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 680.0,
        name: "Chicken Chest (Regular)",
        quantity: 2,
      },
      {
        calories: 192.0,
        name: "Chicken Wing (Regular)",
        quantity: 2,
      },
      {
        calories: 464.0,
        name: "Chicken Thigh (Regular)",
        quantity: 2,
      },
      {
        calories: 256.0,
        name: "Chicken Drumstick (Regular)",
        quantity: 2,
      },
      {
        calories: 376.0,
        name: "Bread Bun",
        quantity: 2,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
    ],
    variations: [
      {
        imageUrl:
          "https://images.staging.waseat.albaikcloud.com/spicy-icon.png",
        name: "Spicy",
        productId: 4,
      },
    ],
  },
  {
    id: 4,
    calories: 2582.0,
    description:
      "Spicy and Crunchy to perfection. Includes 2 buns, fries, and 4 garlic sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 6,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-pfc-8pc-tpos.jpg",
    name: "ALBAIK 8 Piece Spicy Chicken Meal",
    price: 3300,
    allergenInformation: {
      egg: "true",
      soy: "false",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 33,
    priceFractionalUnit: 0,
    options: [
      {
        id: 106347,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181553,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181553,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106348,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181554,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181554,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106349,
        name: "Third Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181555,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181555,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106350,
        name: "Fourth Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181556,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181556,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 740.0,
        name: "Chicken Chest (Spicy)",
        quantity: 2,
      },
      {
        calories: 542.0,
        name: "Chicken Thigh (Spicy)",
        quantity: 2,
      },
      {
        calories: 250.0,
        name: "Chicken Drumstick (Spicy)",
        quantity: 2,
      },
      {
        calories: 194.0,
        name: "Chicken Wing (Spicy)",
        quantity: 2,
      },
      {
        calories: 376.0,
        name: "Bread Bun",
        quantity: 2,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
    ],
    variations: [],
  },
  {
    id: 5,
    calories: 1052.0,
    description:
      "Crunchy to perfection. Includes a bun, fries, and 2 nugget sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 3,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-nuggets-7pc-tpos.jpg",
    name: "7 Piece Chicken Nuggets Meal ",
    price: 1150,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 11,
    priceFractionalUnit: 50,
    options: [
      {
        id: 106351,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181557,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181557,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106352,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181558,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181558,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 490.0,
        name: "Chicken Nugget (Regular)",
        quantity: 7,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
      {
        calories: 188.0,
        name: "Bread Bun",
        quantity: 1,
      },
    ],
    variations: [
      {
        imageUrl:
          "https://images.staging.waseat.albaikcloud.com/spicy-icon.png",
        name: "Spicy",
        productId: 6,
      },
    ],
  },
  {
    id: 6,
    calories: 1066.0,
    description:
      "Spicy and Crunchy to perfection. Includes a bun, fries, and 2 nugget sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 8,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-nuggets-7pc-tpos.jpg",
    name: "7 Piece Spicy Chicken Nuggets Meal ",
    price: 1150,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 11,
    priceFractionalUnit: 50,
    options: [
      {
        id: 106353,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181559,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181559,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106354,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181560,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181560,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 504.0,
        name: "Chicken Nugget (Spicy)",
        quantity: 7,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
      {
        calories: 188.0,
        name: "Bread Bun",
        quantity: 1,
      },
    ],
    variations: [],
  },
  {
    id: 7,
    calories: 1262.0,
    description:
      "Crunchy to perfection. Includes a bun, fries, and 2 nuggets sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 4,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-nuggets-10pc-tpos.jpg",
    name: "10 Piece Chicken Nuggets Meal",
    price: 1500,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 15,
    priceFractionalUnit: 0,
    options: [
      {
        id: 106355,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181561,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181561,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106356,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181562,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181562,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 700.0,
        name: "Chicken Nugget (Regular)",
        quantity: 10,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
      {
        calories: 188.0,
        name: "Bread Bun",
        quantity: 1,
      },
    ],
    variations: [
      {
        imageUrl:
          "https://images.staging.waseat.albaikcloud.com/spicy-icon.png",
        name: "Spicy",
        productId: 8,
      },
    ],
  },
  {
    id: 8,
    calories: 1282.0,
    description:
      "Spicy and Crunchy to perfection. Includes a bun, fries, and 2 nuggets sauces.",
    filterCategories: ["chicken", "plate"],
    filterOrder: 9,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-nuggets-10pc-tpos.jpg",
    name: "10 Piece Spicy Chicken Nuggets Meal",
    price: 1500,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 15,
    priceFractionalUnit: 0,
    options: [
      {
        id: 106357,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181563,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181563,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106358,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181564,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "false",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 33.0,
            default: true,
            id: 181564,
            imageUrl: null,
            name: "Nugget Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 720.0,
        name: "Chicken Nugget (Spicy)",
        quantity: 10,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
      {
        calories: 188.0,
        name: "Bread Bun",
        quantity: 1,
      },
    ],
    variations: [],
  },
  {
    id: 9,
    calories: 1270.0,
    description:
      "6 fish fillet Nuggets served with fries, a bun and 2 tartar sauces.",
    filterCategories: ["fish", "seafood", "plate"],
    filterOrder: 15,
    imageUrl: "https://images.staging.waseat.albaikcloud.com/fish-reg-tpos.jpg",
    name: "Fish Fillet Meal",
    price: 1650,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "true",
      milk: "true",
      gluten: "true",
      sesame: "true",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 16,
    priceFractionalUnit: 50,
    options: [
      {
        id: 106478,
        name: "First Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 75.0,
            default: true,
            id: 181726,
            imageUrl: null,
            name: "Tartar Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 75.0,
            default: true,
            id: 181726,
            imageUrl: null,
            name: "Tartar Sauce (Small)",
            price: 0,
          },
        ],
      },
      {
        id: 106479,
        name: "Second Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 75.0,
            default: true,
            id: 181727,
            imageUrl: null,
            name: "Tartar Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 75.0,
            default: true,
            id: 181727,
            imageUrl: null,
            name: "Tartar Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 624.0,
        name: "Fish Fillet (Regular)",
        quantity: 6,
      },
      {
        calories: 308.0,
        name: "Fries",
        quantity: 1,
      },
      {
        calories: 188.0,
        name: "Bread Bun",
        quantity: 1,
      },
    ],
    variations: [],
  },
  {
    id: 10,
    calories: 158.0,
    description:
      "5 piece chicken fingers. Perfect for those hunger pangs between meals.",
    filterCategories: ["chicken", "side", "extra"],
    filterOrder: 2,
    imageUrl: "https://images.staging.waseat.albaikcloud.com/snack-tpos.jpg",
    name: "Fillet Nugget Snacks",
    price: 450,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "false",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 4,
    priceFractionalUnit: 50,
    options: [
      {
        id: 106359,
        name: " Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181565,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "false",
              milk: "true",
              gluten: "true",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 43.0,
            default: true,
            id: 181565,
            imageUrl: null,
            name: "Garlic Sauce (Small)",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 115.0,
        name: "Snack Finger ",
        quantity: 5,
      },
    ],
    variations: [],
  },
  {
    id: 12,
    calories: 373.0,
    description:
      "Chicken Fillet Nugget wrapped in Arabic bread with garlic sauce, pickles, and fries.",
    filterCategories: ["chicken", "sandwich"],
    filterOrder: 1,
    imageUrl:
      "https://images.staging.waseat.albaikcloud.com/chicken-sandwich-tpos.jpg",
    name: "Chicken Fillet Sandwich",
    price: 600,
    allergenInformation: {
      egg: "true",
      soy: "true",
      fish: "false",
      milk: "true",
      gluten: "true",
      sesame: "false",
      mustard: "false",
      shellfish: "false",
    },
    countryCode: "SA",
    priceMainUnit: 6,
    priceFractionalUnit: 0,
    calorieBurnTime: null,
    sodium: 1096.0,
    options: [
      {
        id: 106371,
        name: "Pickles",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181580,
            imageUrl: null,
            name: "Without Pickles",
            price: 0,
          },
          {
            additive: true,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: true,
            id: 181579,
            imageUrl: null,
            name: "With Pickles",
            price: 0,
          },
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181836,
            imageUrl: null,
            name: "Without Pickles",
            price: 0,
          },
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: true,
            id: 181837,
            imageUrl: null,
            name: "With Pickles",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181580,
            imageUrl: null,
            name: "Without Pickles",
            price: 0,
          },
          {
            additive: true,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: true,
            id: 181579,
            imageUrl: null,
            name: "With Pickles",
            price: 0,
          },
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181836,
            imageUrl: null,
            name: "Without Pickles",
            price: 0,
          },
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: true,
            id: 181837,
            imageUrl: null,
            name: "With Pickles",
            price: 0,
          },
        ],
      },
      {
        id: 106370,
        name: "Garlic Sauce",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181577,
            imageUrl: null,
            name: "Without Garlic Sauce",
            price: 0,
          },
          {
            additive: true,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "true",
              milk: "true",
              gluten: "true",
              sesame: "true",
              mustard: "true",
              shellfish: "true",
            },
            calories: 0.0,
            default: true,
            id: 181576,
            imageUrl: null,
            name: "With Garlic Sauce",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181577,
            imageUrl: null,
            name: "Without Garlic Sauce",
            price: 0,
          },
          {
            additive: true,
            allergenInformation: {
              egg: "true",
              soy: "true",
              fish: "true",
              milk: "true",
              gluten: "true",
              sesame: "true",
              mustard: "true",
              shellfish: "true",
            },
            calories: 0.0,
            default: true,
            id: 181576,
            imageUrl: null,
            name: "With Garlic Sauce",
            price: 0,
          },
        ],
      },
      {
        id: 106372,
        name: "Fries",
        multipleChoices: false,
        required: true,
        nutritionalInformation: [
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181582,
            imageUrl: null,
            name: "Without Fries",
            price: 0,
          },
          {
            additive: true,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: true,
            id: 181581,
            imageUrl: null,
            name: "With Fries",
            price: 0,
          },
        ],
        choices: [
          {
            additive: false,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: false,
            id: 181582,
            imageUrl: null,
            name: "Without Fries",
            price: 0,
          },
          {
            additive: true,
            allergenInformation: {
              egg: "false",
              soy: "false",
              fish: "false",
              milk: "false",
              gluten: "false",
              sesame: "false",
              mustard: "false",
              shellfish: "false",
            },
            calories: 0.0,
            default: true,
            id: 181581,
            imageUrl: null,
            name: "With Fries",
            price: 0,
          },
        ],
      },
    ],
    nutritionalInformation: [
      {
        calories: 373.0,
        name: "Chicken Fillet Sandwich (Regular)",
        quantity: 1,
      },
    ],
    variations: [
      {
        imageUrl:
          "https://images.staging.waseat.albaikcloud.com/spicy-icon.png",
        name: "Spicy",
        productId: 13,
      },
    ],
  },
];

export const makeProduct = (overrides: Partial<Product> = {}): Product => ({
  id: 1,
  calories: 0,
  description: "",
  filterCategories: [],
  filterOrder: 0,
  imageUrl: "",
  name: "Test Product",
  nutritionalInformation: [],
  options: null,
  price: 10,
  variations: [],
  schedule: [],
  allergenInformation: {
    egg: "",
    fish: "",
    milk: "",
    mustard: "",
    sesame: "",
    crustaceans: "",
    soy: "",
    gluten: "",
  },
  countryCode: "SA",
  ...overrides,
});
